import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

interface UIState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;

  // 모달/시트
  loginModalOpen: boolean;
  setLoginModalOpen: (open: boolean) => void;

  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;

  /** 브라우저 종료 시 자동 로그아웃 */
  logoutOnClose: boolean;
  setLogoutOnClose: (v: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set, get) => ({
      theme: 'light',
      setTheme: (theme) => {
        document.documentElement.setAttribute('data-theme', theme);
        set({ theme });
      },
      toggleTheme: () => {
        const next = get().theme === 'light' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', next);
        set({ theme: next });
      },

      loginModalOpen: false,
      setLoginModalOpen: (open) => set({ loginModalOpen: open }),

      sidebarOpen: false,
      setSidebarOpen: (open) => set({ sidebarOpen: open }),

      logoutOnClose: false,
      setLogoutOnClose: (v) => set({ logoutOnClose: v }),
    }),
    {
      name: 'sisegonggan:ui',
      partialize: (state) => ({
        theme: state.theme,
        logoutOnClose: state.logoutOnClose,
      }),
    },
  ),
);
